import React, { useEffect } from 'react';
import './whychoose.css';
import AOS from 'aos';
import 'aos/dist/aos.css';

// Assets
import centerImg from '../../assets/why-choose-us-mainimage.png';
import icon1 from '../../assets/why-img-1.png';
import icon2 from '../../assets/why-img-2.png';
import icon3 from '../../assets/why-img-3.png';
import icon4 from '../../assets/why-img-4.png';

function Whychoose() {

  useEffect(() => {
    AOS.init({
      duration: 1000, // Animation duration
      once: true,     // Only animate once
    });
  }, []);

  return (
    <div className="whychoose-section">
      {/* WHY CHOOSE US SECTION */}
      <div className="container whychoose-container">
        
        {/* Header text */}
        <div className="header-textt" data-aos="fade-up">
          <h3>What We Do</h3>
          <h2 style={{ color: 'white' }}>
            We elevate your online presence and transform your ideas into reality
          </h2>
        </div>

        {/* Left side icons */}
        <div className="whychoose-item left">
          <div className="whychoose-box" data-aos="fade-right">
            <img src={icon1} alt="Expert Team" />
            <h4>Expert Team</h4>
            <p>
              Our experienced team of designers, developers, editors, analysts, and marketers
              work together to bring your vision to life.
            </p>
          </div>

          <div className="whychoose-box" data-aos="fade-right" data-aos-delay="200">
            <img src={icon3} alt="Transparent Reporting" />
            <h4>Transparent Reporting</h4>
            <p>
              We provide clear, easy-to-understand reports so you know how your website and
              marketing campaigns are performing.
            </p>
          </div>
        </div>

        {/* Center image */}
        <div className="whychoose-center" data-aos="zoom-in">
          <img src={centerImg} alt="Why Choose Us" />
        </div>

        {/* Right side icons */}
        <div className="whychoose-item right">
          <div className="whychoose-box" data-aos="fade-left">
            <img src={icon2} alt="Ongoing Support" />
            <h4>Ongoing Support</h4>
            <p>
              We’re here every step of the way, offering ongoing support to ensure your site
              and marketing succeed.
            </p>
          </div>

          <div className="whychoose-box" data-aos="fade-left" data-aos-delay="200">
            <img src={icon4} alt="Affordable Pricing" />
            <h4>Affordable Pricing</h4>
            <p>
              High-quality services at competitive prices, helping businesses of all sizes
              grow online.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Whychoose;
